import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const COLORS = [
  "rgb(136, 132, 216)",
  "rgb(158, 154, 226)",
  "rgb(118, 114, 196)",
  "rgb(100, 96, 176)",
];

const FullPieChart = ({ category = [], product = [] }) => {
  const [data, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [legendItemsShown, setLegendItemsShown] = useState(0);
  const [chartType, setChartType] = useState("category"); // 'category' or 'product'

  useEffect(() => {
    let source = chartType === "category" ? category : product;
    if (Array.isArray(source)) {
      const formatted = source.map((item) => ({
        name: chartType === "category" ? item.category : item.product_name,
        value: Number(item.total_sales),
      }));
      setData(formatted);
    }
  }, [category, product, chartType]);

  useEffect(() => {
    const interval = setInterval(() => {
      setLegendItemsShown((prev) => {
        if (prev < data.length) return prev + 1;
        clearInterval(interval);
        return prev;
      });
    }, 500);
    return () => clearInterval(interval);
  }, [data]);

  const totalSales = data.reduce((sum, item) => sum + item.value, 0);
  const onPieEnter = (_, index) => setActiveIndex(index);
  const onPieLeave = () => setActiveIndex(null);

  const renderCenterText = () => {
    const item = data[activeIndex];
    return activeIndex !== null ? (
      <>
        <text
          x="50%"
          y="4%"
          textAnchor="middle"
          dominantBaseline="central"
          style={{ fontSize: 12, fill: "#6A0DAD", fontWeight: "bold" }}
        >
          {item.name}
        </text>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          style={{ fontSize: 18, fill: "#8A2BE2", fontWeight: "bold" }}
        >
          ₹{item.value.toLocaleString()}
        </text>
      </>
    ) : (
      <>
        <text
          x="50%"
          y="4%"
          textAnchor="middle"
          dominantBaseline="central"
          style={{ fontSize: 16, fill: "#6A0DAD", fontWeight: "bold" }}
        >
          Total Sales
        </text>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          style={{ fontSize: 18, fill: "#8A2BE2", fontWeight: "bold" }}
        >
          ₹{totalSales.toLocaleString()}
        </text>
      </>
    );
  };

  return (
    <div style={{ width: 400, height: 420, textAlign: "center" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ margin: 0 }}>Sales Overview</h3>
        <select
          value={chartType}
          onChange={(e) => {
            setLegendItemsShown(0);
            setChartType(e.target.value);
          }}
          style={{
            padding: "4px 8px",
            fontSize: 14,
            borderRadius: 4,
            border: "1px solid #ccc",
            backgroundColor: "#fff",
          }}
        >
          <option value="category">Category Wise</option>
          <option value="product">Product Wise</option>
        </select>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            outerRadius={100}
            innerRadius={60}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            onMouseEnter={onPieEnter}
            onMouseLeave={onPieLeave}
            isAnimationActive={true}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
            {renderCenterText()}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <div
        style={{
          marginTop: 0,
          height: "100px",
          overflowY: "auto",
          paddingRight: 8,
        }}
      >
        {data.slice(0, legendItemsShown).map((item, index) => (
          <div
            key={index}
            style={{
              color: "#444",
              fontSize: 14,
              margin: "4px 0",
              display: "flex",
              alignItems: "center",
              gap: 8,
              opacity: 1,
              transition: "opacity 0.3s",
            }}
          >
            <div
              style={{
                width: 12,
                height: 12,
                marginRight: 4,
                border: "1px solid #ccc",
                borderRadius: "50%",
                backgroundColor: COLORS[index % COLORS.length],
              }}
            />
            {item.name}
            <span style={{ marginLeft: "auto", fontWeight: "bold" }}>
              ₹{item.value.toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FullPieChart;
